// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2WhBw","productName":"Table_productName__3XZhB"};